import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.petsuitesPurple,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.petsuitesPurple,
  iconBorderColor: colors.petsuitesPurple,
  iconBorderHoverColor: colors.petsuitesPurple
};
export default socialIcon;